import { render, staticRenderFns } from "./CreateStaff.vue?vue&type=template&id=c9e232ce&"
import script from "./CreateStaff.vue?vue&type=script&lang=js&"
export * from "./CreateStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports